import { INCREMENT } from "./actionTypes";
import { DECREMENT } from "./actionTypes";
import { ADD_TO_CART } from "./actionTypes";

const initialState = {
    products: [
        {
            name: "Asus Vivobook X515MA",
            id: 1,
            price: 35500,
            quantity: 20
        },
        {
            name: "Asus Vivobook X515MA",
            id: 2,
            price: 9300,
            quantity: 35
        },
        {
            name: "Asus Vivobook X515MA",
            id: 3,
            price: 36500,
            quantity: 72
        }
    ],
    cart: [],
    incValue : 0,
    decValue : 0,
    currentItem: null,
};
let i = 0;
const addToCartReducer = (state = initialState, action) => {

    switch (action.type) {
        case ADD_TO_CART:
            const item = state.products.find(prod => prod.id === action.payload.id);
            const inCart = state.cart.find(item => item.id === action.payload.id ? true : false);

            return {
                ...state,
                products: state.products.map((item) => 
                    item.id === action.payload.id
                        ? {...item, quantity: item.quantity - 1}
                        : item
                ),
                cart: inCart
                    ? state.cart.map((item) =>
                        item.id === action.payload.id
                            ? { ...item, qty: item.qty + 1 }
                            : item
                    )
                    : [...state.cart, { ...item, qty: 1 }],
            };
        case INCREMENT:
            // const incQty = state.products.find(prod => prod.id === action.payload);
            // console.log("incQty: ", incQty);
            // const iteminCart = state.cart.find(item => item.id === action.payload ? true : false);
            // console.log("Itemin cart :", iteminCart)

            return {
                ...state,
                products: state.products.map((item) => 
                item.id === action.payload
                    ? {...item, quantity: item.quantity - 1}
                    : item
                 ),
                cart: state.cart.map((item) =>
                  item.id === action.payload
                    ? { ...item, qty: item.qty + 1 }
                    : item
                ),
              };
            

        case DECREMENT:
            return {
                ...state,
                products: state.products.map((item) => 
                item.id === action.payload
                    ? {...item, quantity: item.quantity + 1}
                    : item
                ),
                cart: state.cart.map((item) =>
                  item.id === action.payload
                    ? { ...item, qty: item.qty - 1 }
                    : item
                ),
              };
           
        default:
            return state;
    }
}

export default addToCartReducer;